import React from 'react';
import styled, { css } from 'styled-components';
import InputMask from 'react-input-mask';
import { AnimatedInput, AnimatedTextarea } from './ui/input';
import { AnimatedSelect } from './ui/select';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: ${props => props.centered ? 'center' : 'space-between'};
  margin-top: 2rem;
  gap: 1rem;
`;

const StyledButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  ${props => props.primary ? css`
    background-color: ${props.theme.colors.primary};
    color: #000000;
    border: none;
    
    &:hover {
      background-color: #ff9a33;
    }
  ` : css`
    background-color: transparent;
    color: ${props.theme.colors.primary};
    border: 1px solid ${props.theme.colors.primary};
    
    &:hover {
      background-color: rgba(255, 127, 0, 0.1);
    }
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const FieldRow = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 0;
  }
`;

// Componente de máscara customizado para usar com AnimatedInput
const MaskedAnimatedInput = ({ mask, ...props }) => {
  return (
    <InputMask mask={mask} {...props}>
      {(inputProps) => (
        <AnimatedInput {...inputProps} mask={mask} />
      )}
    </InputMask>
  );
};

export const FormField = ({ label, name, type, placeholder, value, onChange, error, mask, options, ...props }) => {
  // Se tem máscara, usa o componente de máscara animado
  if (mask) {
    return (
      <MaskedAnimatedInput
        id={name}
        name={name}
        mask={mask}
        label={label}
        value={value}
        onChange={onChange}
        error={error}
        {...props}
      />
    );
  }
  
  // Se é select, usa o select animado
  if (type === 'select') {
    return (
      <AnimatedSelect
        id={name}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        error={error}
        options={options}
        placeholder={placeholder}
        {...props}
      />
    );
  }
  
  if (type === 'textarea') {
    return (
      <AnimatedTextarea
        id={name}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        error={error}
        placeholder={placeholder}
        {...props}
      />
    );
  }
  
  // Para inputs normais, usa o input animado
  return (
    <AnimatedInput
      id={name}
      name={name}
      type={type || 'text'}
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      {...props}
    />
  );
};

export const Button = ({ children, primary, fullWidth, ...props }) => {
  return (
    <StyledButton primary={primary} fullWidth={fullWidth} {...props}>
      {children}
    </StyledButton>
  );
};

export const ButtonGroup = ({ children, centered }) => {
  return (
    <ButtonContainer centered={centered}>
      {children}
    </ButtonContainer>
  );
};

export const Row = ({ children }) => {
  return <FieldRow>{children}</FieldRow>;
};
